import React from "react";
import { CSSTransition } from "react-transition-group";

export default function TransitionIn(props) {
    return (
        <CSSTransition classNames="transition-in" {...props}>
            {props.children}
        </CSSTransition>
    );
}
